import { render, staticRenderFns } from "./ClickSearchPopup.vue?vue&type=template&id=a3b8b6d2&scoped=true"
import script from "./ClickSearchPopup.vue?vue&type=script&lang=js"
export * from "./ClickSearchPopup.vue?vue&type=script&lang=js"
import style0 from "./ClickSearchPopup.vue?vue&type=style&index=0&id=a3b8b6d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3b8b6d2",
  null
  
)

export default component.exports